export default __webpack_public_path__ + "static/media/Qios_logo-01-crop.3b69e6b5.png";